<template>
  <!-- eslint-disable max-len -->
  <div class="bpc-table-documents">
      
      <bpc-table-header :fields="fields" :filters="filters" :pagination="pagination" :view="view"></bpc-table-header>

      <b-table v-if="viewIsTable()" class="table-lg" show-empty
               stacked="md"
               :items="items"
               :fields="fields"
               :current-page="pagination.currentPage"
               :per-page="pagination.perPage"
               :filter="filter"
               :sort-by.sync="pagination.sortBy"
               :sort-desc.sync="pagination.sortDesc"
               :sort-direction="pagination.sortDirection"
               @filtered="onFiltered"
      >
        <template v-slot:head(check)>
          <div class="custom-checkbox custom-control">
            <input type="checkbox" id="checkAll" class="custom-control-input" v-on:click="checkAll()">
            <label class="custom-control-label" for="checkAll">&nbsp;</label>
          </div>
        </template>

        <template v-slot:head(img_url)="row">
          <i class="vsm-icon pe-7s-user"></i>
        </template>

        <template v-slot:cell(checked)="row">
          <div class="custom-checkbox custom-control">
            <input type="checkbox" :id="'checkRow'+row.index" class="custom-control-input" v-model="row.item.checked" v-on:click="checkOne()">
            <label class="custom-control-label" :for="'checkRow'+row.index">&nbsp;</label>
          </div>
        </template>

        <template v-slot:cell(img_url)="row">
          <div class="avatar-icon-wrapper _avatar-icon-sm"><div class="avatar-icon"><img :src="row.value" alt=""></div></div>
        </template>

        <template v-slot:cell(code)="row">
          <router-link :to="'/mockups/admin/documents/'+row.value.id" tag="button">
            <b-button variant="link" class="p-0 font-weight-normal">
              [{{ row.value }}]
            </b-button>
          </router-link>
        </template>

        <template v-slot:cell(name)="row">
          <router-link :to="'/mockups/admin/documents/'+row.value.id" tag="button">
            <b-button variant="link" class="p-0 font-weight-normal">
              <span class="last">{{ row.value.last }}</span> <span class="first">{{ row.value.first }}</span>
            </b-button>
          </router-link>
        </template>

        <template v-slot:cell(birthdate)="row">
          {{ row.value.date }} <span v-if="row.value.age">({{ row.value.age }})</span>
        </template>

        <template v-slot:cell(relations)="row">
          <div class="avatar-wrapper avatar-wrapper-overlap">
            <div v-for="(value, key) in row.value" :key="key" class="avatar-icon-wrapper avatar-icon-sm">
              <b-dropdown toggle-class="p-0 mr-2" menu-class="dropdown-menu-lg" variant="link" no-caret right>
                <span slot="button-content">
                    <div class="icon-wrapper icon-wrapper-alt rounded-circle">
                        <img width="42" class="rounded-circle" :src="items[value.document_id].img_url" alt="">
                    </div>
                </span>
                <!-- <bpc-mini-document :item="items[value.document_id]"></bpc-mini-document> -->
              </b-dropdown>
            </div>
          </div>
        </template>

        <template v-slot:cell(ongoing)="row">
          <button v-if="row.value.subscriptions" class="pl-0 py-0 btn-icon btn-icon-only btn btn-link btn-sm">
            <i class="vsm-icon pe-7s-id btn-icon-wrapper font-size-xlg"> </i><span class="p-0 ml-0 badge _badge-pill _badge-primary">{{row.value.subscriptions}}</span></button>
          <button v-if="row.value.bookings" class="pl-0 py-0 btn-icon btn-icon-only btn btn-link btn-sm">
            <i class="vsm-icon pe-7s-bookmarks btn-icon-wrapper font-size-xlg"> </i><span class="p-0 ml-0 badge _badge-pill _badge-primary">{{row.value.bookings}}</span></button>
          <button v-if="row.value.activities" class="pl-0 py-0 btn-icon btn-icon-only btn btn-link btn-sm">
            <i class="vsm-icon pe-7s-joy btn-icon-wrapper font-size-xlg"> </i><span class="p-0 ml-0 badge _badge-pill _badge-primary">{{row.value.activities}}</span></button>
          <button v-if="row.value.registrations" class="pl-0 py-0 btn-icon btn-icon-only btn btn-link btn-sm">
            <i class="vsm-icon pe-7s-ticket btn-icon-wrapper font-size-xlg"> </i><span class="p-0 ml-0 badge _badge-pill _badge-primary">{{row.value.registrations}}</span></button>
        </template>
        <template v-slot:cell(status)="row">
          <div v-if="row.value == 'inactive'" class="badge badge-pill badge-danger">Inactive</div>
          <div v-if="row.value == 'active'" class="badge badge-pill badge-success">Active</div>
        </template>
        <!-- <template v-slot:cell(isActive)="row">{{row.value?'Yes :)':'No :('}}</template> -->
        <template v-slot:cell(actions)>
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <!-- <b-button size="sm" @click.stop="row.toggleDetails">
            {{ row.detailsShowing ? 'Hide' : 'Show' }} Details
          </b-button> -->
          <!-- <button type="button" class="btn btn-sm btn-info">
            <font-awesome-icon icon="edit"/>
          </button>
          <button type="button" class="ml-2 btn btn-sm btn-danger">
            <font-awesome-icon icon="trash"/>
          </button>
          <button type="button" class="ml-2 btn btn-sm btn-secondary">
            <font-awesome-icon icon="ellipsis-h"/>
          </button> -->
          <b-button-group>
            <router-link to="/mockups/admin/documents/1" tag="button">
              <b-button variant="outline-link" class="border-0 btn-transition">
                <i class="vsm-icon pe-7s-note"></i>
              </b-button>
            </router-link>
            <b-button variant="outline-link" class="border-0 btn-transition">
              <i class="vsm-icon pe-7s-trash"></i>
            </b-button>
            <b-button variant="outline-link" class="border-0 btn-transition">
              <i class="vsm-icon pe-7s-more"></i>
            </b-button>
          </b-button-group>
        </template>

        <template slot="row-details" slot-scope="row">
          <b-card class="no-shadow">
            <ul class="list-group">
              <li class="list-group-item" v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value}}</li>
            </ul>
          </b-card>
        </template>

      </b-table>

      <!-- <div class="row m-1">
        <div v-for="(value, key) in items" :key="key" class="col-md-12 col-lg-6 col-xl-4">
          

                    <div class="card-hover-shadow profile-responsive card-border border-primary mb-3 card">
                      <div class="dropdown-menu-header">
                        <div class="dropdown-menu-header-inner bg-info">
                            <div class="menu-header-image opacity-2 dd-header-bg-6"></div>
                            <div class="menu-header-content text-left">
                                <div class="widget-content p-0">
                                    <div class="widget-content-wrapper">
                                        <div class="widget-content-left mr-3">
                                            <img width="42" class="rounded-circle" :src="value.img_url" alt="">
                                        </div>
                                        <div class="widget-content-left">
                                            <div class="widget-heading">{{value.name.last}} {{value.name.first}}</div>
                                            <div class="widget-subheading opacity-8">{{value.relation}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="value.document_details.phone || value.document_details.phone2 || value.document_details.email || value.document_details.email2" class="scroll-area-xs" style="height: auto">
                        <VuePerfectScrollbar class="scrollbar-container">
                          <ul class="document-details">
                            <li>
                              <a v-if="value.document_details.phone" href="javascript:void(0);" class="btn btn-link">
                                <i class="pe-7s-phone mr-2"></i>
                                {{value.document_details.phone}}</a>
                            </li>
                            <li>
                              <a v-if="value.document_details.phone2" href="javascript:void(0);" class="btn btn-link">
                                <i class="pe-7s-phone mr-2"></i>
                                {{value.document_details.phone2}}</a>
                            </li>
                            <li>
                              <a v-if="value.document_details.email" href="javascript:void(0);" class="btn btn-link">
                                {{value.document_details.email}}</a>
                            </li>
                            <li>
                              <a v-if="value.document_details.email2" href="javascript:void(0);" class="btn btn-link">
                                {{value.document_details.email2}}</a>
                            </li>
                          </ul>
                        </VuePerfectScrollbar>
                    </div>
                    <ul class="nav flex-column">
                        <li class="nav-item-divider mb-0 nav-item"></li>
                    </ul>
                    <div class="grid-menu grid-menu-2col overflow-hidden">
                        <div class="no-gutters row">
                            <div class="col-sm-6">
                                <button class="_btn-icon-vertical _btn-transition _btn-transition-alt _pt-2 _pb-2 btn _btn-outline-warning"><i class="pe-7s-chat _icon-gradient _bg-amy-crisp _btn-icon-wrapper mr-2"> </i>Message</button>
                            </div>
                            <div class="col-sm-6">
                                <button class="_btn-icon-vertical _btn-transition _btn-transition-alt _pt-2 _pb-2 btn _btn-outline-danger"><i class="pe-7s-ticket _icon-gradient _bg-love-kiss _btn-icon-wrapper mr-2"> </i><b>View</b>
                                </button>
                            </div>
                        </div>
                    </div>
                    </div>

        </div>
      </div> -->

      <bpc-table-footer :pagination="pagination"></bpc-table-footer>

  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faEllipsisH,
} from '@fortawesome/free-solid-svg-icons';


import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import BpcTableHeader from '@/mockups/layouts/components/BpcTableHeader.vue';
import BpcTableFooter from '@/mockups/layouts/components/BpcTableFooter.vue';
// import BpcMiniDocument from '@/mockups/mini/BpcMiniDocument.vue';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

import avatar1 from '../assets/avatars/1.jpg';
import avatar2 from '../assets/avatars/2.jpg';
import avatar3 from '../assets/avatars/3.jpg';
import avatar4 from '../assets/avatars/4.jpg';
import avatar5 from '../assets/avatars/5.jpg';
import avatar6 from '../assets/avatars/6.jpg';
import avatar7 from '../assets/avatars/7.jpg';
import avatar8 from '../assets/avatars/8.jpg';
import avatar9 from '../assets/avatars/9.jpg';
import avatar10 from '../assets/avatars/10.jpg';

library.add(
  faStar,
  faPlus,
  faTrash,
  faPlay,
  faForward,
  faRocket,
  faQuestion,
  faEdit,
  faEllipsisH,
);

const items = [
  {
    checked: false,
    code: '004567',
    birthdate: { date: '1979-08-24', age: 40 },
    type: 'Individual',
    status: 'active',
    name: { id: 1, first: 'Dickerson', last: 'Macdonald' },
    img_url: avatar1,
    document_details: {
      phone: '0477/12.34.56',
      phone2: '02/123.45.67',
      email: 'info@email.com',
      email2: 'demo@admin.be',
    },
    relations: [
      {
        document_id: 1,
        relation: 'Husband',
      },
      {
        document_id: 3,
        relation: 'Director',
      },
    ],
    ongoing: {
      bookings: 3,
    }
  },
  {
    checked: false,
    code: '023567',
    birthdate: { date: '1998-10-15', age: 21 },
    type: 'Individual',
    status: 'active',
    name: { id: 2, first: 'Larsen', last: 'Shaw' },
    img_url: avatar2,
    document_details: {
      phone: '04/56.78.90',
      phone2: '',
      email: 'larsen.shaw@test.com',
      email2: 'demo@admin.be',
    },
    relations: [
      {
        document_id: 1,
        relation: 'Wife',
      },
      {
        document_id: 3,
        relation: 'Secretary',
      },
    ],
    ongoing: {
      subscriptions: 2,
      bookings: 10,
      registrations: 2,
    }
  },
  {
    checked: false,
    code: '000653',
    birthdate: { date: null, age: null },
    type: 'School',
    status: 'inactive',
    name: { id: 1, first: 'High School V', last: '' },
    img_url: avatar3,
    document_details: {
      phone: '012/345.678',
      phone2: '',
      email: 'info@highschoolv.com',
      email2: '',
    },
    relations: [
      {
        document_id: 1,
        relation: 'Director',
      },
      {
        document_id: 2,
        relation: 'Secretary',
      },
      {
        document_id: 6,
        relation: 'Treasurer',
      },
      {
        document_id: 7,
        relation: 'Teacher',
      },
    ],
    ongoing: {
      bookings: 1,
      registrations: 2,
    }
    // _rowVariant: 'success',
  },
  {
    checked: false,
    code: '000078',
    birthdate: { date: null, age: null },
    type: 'Company',
    status: 'active',
    name: { id: 1, first: 'Google', last: '' },
    img_url: avatar8,
    document_details: {
      phone: '001(67)345.987',
      phone2: '',
      email: 'info@google.com',
      email2: '',
    },
    relations: [
      {
        document_id: 9,
        relation: 'CEO',
      },
      {
        document_id: 10,
        relation: 'Member',
      },
    ],
    ongoing: {
      subscriptions: 1,
      registrations: 3,
    }
  },
  {
    checked: false,
    code: '123456',
    birthdate: { date: null, age: null },
    type: 'Club',
    status: 'active',
    name: { id: 1, first: 'Speedy MSG', last: '' },
    img_url: avatar9,
    document_details: {
      phone: '',
      phone2: '',
      email: 'info@speedymsg.be',
      email2: '',
    },
    relations: [
      {
        document_id: 9,
        relation: 'President',
      },
    ],
    ongoing: {
      bookings: 14,
      activities: 6,
    }
  },
  {
    checked: false,
    code: '987034',
    birthdate: { date: '1979-08-24', age: 40 },
    type: 'Individual',
    status: 'active',
    name: { id: 1, first: 'Essie', last: 'Dunlap' },
    img_url: avatar4,
    document_details: {},
    relations: [
      {
        document_id: 3,
        relation: 'Treasurer',
      },
    ],
    ongoing: {}
  },
  {
    checked: false,
    code: '0009745',
    birthdate: { date: '1957-07-23', age: 63 },
    type: 'Individual',
    status: 'active',
    name: { id: 1, first: 'Thor', last: 'Macdonald' },
    img_url: avatar5,
    document_details: {
      phone: '',
      phone2: '',
      email: 'thor@microsoft.com',
      email2: 'demo@admin.be',
    },
    relations: [
      {
        document_id: 3,
        relation: 'Teacher',
      },
    ],
    ongoing: {
      subscriptions: 2,
    }
  },
  {
    checked: false,
    code: '008934',
    birthdate: { date: null, age: null },
    type: 'Club',
    status: 'inactive',
    name: { id: 1, first: 'Tennis Club', last: '' },
    img_url: avatar6,
    document_details: {
      phone: '0477/12.34.56',
      phone2: '02/123.45.67',
      email: '',
      email2: '',
    },
    relations: [],
    ongoing: {
      bookings: 1,
    }
    // _cellVariants: { age: 'danger', isActive: 'warning' },
  },
  {
    checked: false,
    code: '000098',
    birthdate: { date: '2004-12-11', age: 16 },
    type: 'Individual',
    status: 'active',
    name: { id: 1, first: 'Mitzi', last: 'Navarro' },
    img_url: avatar7,
    document_details: {
      phone: '0477/12.34.56',
      phone2: '02/123.45.67',
      email: 'info@email.com',
      email2: 'demo@admin.be',
    },
    relations: [
      {
        document_id: 4,
        relation: 'CEO',
      },
      {
        document_id: 5,
        relation: 'President',
      },
    ],
      ongoing: {
      subscriptions: 1,
      bookings: 5,
    }
},
  {
    checked: false,
    code: '563009',
    birthdate: { date: '2008-05-30', age: 12 },
    type: 'Individual',
    status: 'active',
    name: { id: 1, first: 'Genevieve', last: 'Wilson' },
    img_url: avatar8,
    document_details: {
      phone: '6',
      phone2: '02/123.45.67',
      email: 'info@email.com',
      email2: '',
    },
    relations: [
      {
        document_id: 4,
        relation: 'Member',
      },
    ],
    ongoing: {
      subscriptions: 1,
      bookings: 2,
    }
  },
  {
    checked: false,
    code: '000542',
    birthdate: { date: '1981-03-02', age: 38 },
    type: 'Individual',
    status: 'active',
    name: { id: 1, first: 'John', last: 'Carney' },
    img_url: avatar9,
    document_details: {
      phone: '+34.605.234.789',
      phone2: '',
      email: 'john@beplusports.com',
      email2: '',
    },
    relations: [],
    ongoing: {}
  },
  {
    checked: false,
    code: '000060',
    birthdate: { date: '1990-08-14', age: 29 },
    type: 'Individual',
    status: 'inactive',
    name: { id: 1, first: 'Dick', last: 'Dunlap' },
    img_url: avatar10,
    document_details: {
      phone: '0477/12.34.56',
      phone2: '02/123.45.67',
      email: 'info@email.com',
      email2: 'demo@admin.be',
    },
    relations: [],
    ongoing: {}
  },
];

export default {
  components: {
    // 'font-awesome-icon': FontAwesomeIcon,
    BpcTableHeader,
    BpcTableFooter,
    // BpcMiniDocument,
    VuePerfectScrollbar,
  },
  props: {
    selection: Array,
  },
  data: () => ({
    header: {
      heading: 'Documents',
      subheading: 'Documents of your sport center',
      icon: '', // 'pe-7s-users icon-gradient bg-tempting-azure',
      breadcrumb: ['Dashboard', 'Documents'],
      links: ['Help', 'Settings'],
      actions: {
        delete: true, bulk: true, new: true, edit: false, actions: true,
      },
    },
    filters: ['search', 'status', 'type'],
    pagination: {
      currentPage: 1,
      perPage: 5,
      totalRows: items.length,
      pageOptions: [5, 10, 20, 50, 100, 200],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
    },
    items,
    fields: [
      // 'index',
      {
        key: 'checked', label: 'Check', class: 'check',
      },
      {
        key: 'img_url', label: 'Pic', class: 'avatar',
      },
      {
        key: 'code', label: '# Ref', class: 'code', sortable: true, sortDirection: 'desc',
      },
      {
        key: 'name', label: 'Full name', class: 'fullname', sortable: true, sortDirection: 'desc',
      },
      {
        key: 'type', label: 'Type', class: 'type', sortable: true, sortDirection: 'desc',
      },
      {
        key: 'birthdate', label: 'Birthdate (age)', class: 'birthdate', sortable: true,
      },
      {
        key: 'relations', label: 'Relations', class: 'relations',
      },
      // {
      //   key: 'ongoing', label: 'Ongoing', class: 'ongoing',
      // },
      {
        key: 'status', label: 'Status', class: 'status', sortable: true, sortDirection: 'desc',
      },
      {
        key: 'actions', label: 'Actions', class: 'actions',
      },
    ],
    filter: null,
    view: 'table',
    modalInfo: { title: '', content: '' },
  }),
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
  },
  methods: {
    info(item, index, button) {
      this.modalInfo.title = `Row index: ${index}`;
      this.modalInfo.content = JSON.stringify(item, null, 2);
      this.$root.$emit('bv::show::modal', 'modalInfo', button);
    },
    resetModal() {
      this.modalInfo.title = '';
      this.modalInfo.content = '';
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    checkOne() {
      console.log(this.items);
      let mySelection = this.selection;
      for (let i = 0; i < this.items.length; i += 1) {
        if (this.items[i].checked) {
          mySelection.push(i);
        }
      }
      console.log(mySelection);
      this.$emit("update-selection", mySelection);
    },
    checkAll() {
      console.log(items);
    },
    viewIsTable() {
      return this.view == 'table';
    },
    viewIsCards() {
      return this.view == 'cards';
    }
  },
};
</script>

<style>
.card-body {
  padding: 0 !important;
}
.card-title {
  padding: 1.25rem 0.825rem 0.5rem;
}
.card-body table {
  margin-bottom: 0;
}
.card-body table tr:last-child {
  border-bottom: 1px solid #e9ecef;
}
.table thead th {
  background-color: #f3f3f3;
  border-bottom-width: 1px !important;
}
.table td {
  vertical-align: middle;
}
.table th.check, .table td.check {
  width: 40px;
  text-align: center;
}
.table th.avatar {
  width: 50px;
  padding: 0 !important;
}
.table th.avatar i {
  font-size: 40px;
  color: rgba(0,0,0,0.2);
}
.table td.avatar {
  padding: 5px 0 0;
}
.table th.code {
  width: 50px;
}
.table td.fullname .last {
  text-transform: uppercase;
}
.table td.relations {
  padding-top: 8px !important;
  padding-bottom: 0px !important;
}
ul.document-details {
  list-style: none;
  margin: 0;
  padding: 0;
}
ul.document-details li {
  display: inline-block;
  width: 50%;
}
.avatar-wrapper .icon-wrapper {
  display: block;
  width: 44px;
  height: 44px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
  opacity: 1;
  border-radius: 50px;
  border: #fff solid 3px;
  overflow: hidden;
  width: 34px;
  height: 34px;
}
.avatar-wrapper .icon-wrapper img {
  width: 100%;
  height: 100%;
}
.avatar-wrapper-overlap .avatar-icon-wrapper.avatar-icon-sm {
  margin-left: -25px;
}
.table th.status {
  width: 80px;
}
.table th.actions {
  width: 110px;
}
.table td.actions {
  padding-top: 0.825rem;
  padding-bottom: 0.825rem;
}
.table td.actions .btn {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
  width: 30px;
  text-align: center;
  font-size: 1rem;
}
.table td.actions .btn-link:hover {
  background-color: #e9ecef;
  border-radius: 3px;
}
</style>
